/* tslint:disable */
/* eslint-disable */
/**
 * chinaone-java
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface WarehouseOption
 */
export interface WarehouseOption {
    /**
     * 仓库ID
     * @type {number}
     * @memberof WarehouseOption
     */
    id?: number;
    /**
     * 仓库名称
     * @type {string}
     * @memberof WarehouseOption
     */
    name?: string;
}

/**
 * Check if a given object implements the WarehouseOption interface.
 */
export function instanceOfWarehouseOption(value: object): value is WarehouseOption {
    return true;
}

export function WarehouseOptionFromJSON(json: any): WarehouseOption {
    return WarehouseOptionFromJSONTyped(json, false);
}

export function WarehouseOptionFromJSONTyped(json: any, ignoreDiscriminator: boolean): WarehouseOption {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
        'name': json['name'] == null ? undefined : json['name'],
    };
}

export function WarehouseOptionToJSON(json: any): WarehouseOption {
    return WarehouseOptionToJSONTyped(json, false);
}

export function WarehouseOptionToJSONTyped(value?: WarehouseOption | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'name': value['name'],
    };
}

